<script>
export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    autosize: {},
  },
  methods: {
    input(e) {
      this.$emit('input', e.target.value);
    },
    change(e) {
      this.$emit('change', e.target.value);
    },
    submit() {
      this.$refs.input.blur();
      this.$emit('submit');
    },
  },
};
</script>
<template>
  <el-input
    ref="input"
    type="textarea"
    :autosize="autosize"
    class="f-c-textarea"
    :value="value"
    :placeholder="placeholder"
    :disabled="disabled"
    @input="$emit('input', $event)"
    @change="$emit('change', $event)"
    @focus="$emit('focus', $event)"
    @blur="$emit('blur', $event)"
  />
</template>
<style lang="scss">
  .f-c-textarea {
    min-height: 24px;

    .el-textarea__inner {
      font-family: Roboto, sans-serif;
      font-size: 16px;
      background: none;
      border: none;
      padding: 0;
      min-height: 24px!important;
    }
  }
</style>
